import { i18n } from '../helpers/i18n';
import { t } from '@lingui/macro';
import { Field } from '../declarations/widget-ums';
import { EMPTY_FIELD } from './emptyField';

export enum CITIZENSHIP {
  CITIZEN = 1, // Начинаем с 1, поскольку 0 это false
  FOREIGN_CITIZEN,
  NON_CITIZEN,
}

export enum DOCUMENT_TYPE {
  PASSPORT_RF = 1,
  BIRTH_CERTIFICATE_RF,
  BIRTH_CERTIFICATE_INTERNATIONAL,
  REFUGEE_ID,
  RESIDENCE,
}

export enum PASSPORT_STATUS {
  VALID = 'valid',
  EXPIRING = 'expiring',
  EXPIRED = 'expired',
}

export enum DOCUMENT_FIELD {
  dul,
  birthCertificate,
}

export const nonRussianCitizenDocuments = [
  { text: i18n._(t`Удостоверение беженца`), value: DOCUMENT_TYPE.REFUGEE_ID },
  { text: i18n._(t`Вид на жительство`), value: DOCUMENT_TYPE.RESIDENCE },
];
export const ADULT_DOCUMENT_OPTIONS = {
  [CITIZENSHIP.CITIZEN]: [
    {
      text: i18n._(t`Паспорт гражданина РФ`),
      value: DOCUMENT_TYPE.PASSPORT_RF,
    },
  ],
  [CITIZENSHIP.FOREIGN_CITIZEN]: nonRussianCitizenDocuments,
  [CITIZENSHIP.NON_CITIZEN]: nonRussianCitizenDocuments,
};
export const CHILD_DOCUMENT_OPTIONS = [
  {
    text: i18n._(t`Свидетельство о рождении РФ`),
    value: DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF,
  },
  {
    text: i18n._(t`Свидетельство о рождении иностранного образца`),
    value: DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL,
  },
];

export type DocumentTypeValue = DOCUMENT_TYPE | null;

export interface DocumentFields {
  birthCertificate: boolean;
  type: Field<DocumentTypeValue>;
  number: Field<string>;
  issuer: Field<string>;
  issueDate: Field<string>;
  divisionCode: Field<string>;
  status: PASSPORT_STATUS;
  input_type?: 'LK' | 'manual_input';
}

export interface PassportWarning {
  status: string;
  passportDueDate: string;
}

export interface DocumentState {
  dul: DocumentFields;
  birthCertificate: DocumentFields;
}

export const documentInitialState = {
  type: { value: null, error: false, disabled: false },
  number: EMPTY_FIELD,
  issuer: EMPTY_FIELD,
  issueDate: EMPTY_FIELD,
  divisionCode: EMPTY_FIELD,
  status: PASSPORT_STATUS.VALID,
};
export const dulInitialState = {
  ...documentInitialState,
  type: { value: DOCUMENT_TYPE.PASSPORT_RF, error: false, disabled: false },
  birthCertificate: false,
};
